import { render, staticRenderFns } from "./HomeRoute.vue?vue&type=template&id=05913218&scoped=true"
import script from "./HomeRoute.vue?vue&type=script&lang=ts"
export * from "./HomeRoute.vue?vue&type=script&lang=ts"
import style0 from "./HomeRoute.vue?vue&type=style&index=0&id=05913218&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05913218",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('05913218')) {
      api.createRecord('05913218', component.options)
    } else {
      api.reload('05913218', component.options)
    }
    module.hot.accept("./HomeRoute.vue?vue&type=template&id=05913218&scoped=true", function () {
      api.rerender('05913218', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/home/HomeRoute.vue"
export default component.exports